import styled, { css } from "styled-components";
import { StatsState } from "../store/chart";
import { Text } from "../components/Text";
import { FontFamily, FontWeight } from "../types";
import { Container } from "./Container";

type StatsProps = {
  className?: string;
  statsSection: StatsState[];
};

export function StatsSection({ className, statsSection }: StatsProps) {
  return (
    <Wrapper className={className}>
      <StyledContainer>
        <StyledStatsGrid>
          {statsSection.map((stat, index) => (
            <StyledStatCard key={`${stat.title}-${index}`}>
              {stat.img && (
                <StyledStatImage>
                  <img
                    src={stat.img.url}
                    alt={`${stat.img.alt || stat.title.value}`}
                  />
                </StyledStatImage>
              )}
              <StyledStatTitle
                font={stat.title.font}
                textColor={stat.title.color}
              >
                {stat.title.value}
              </StyledStatTitle>
              <StyledStatDescription
                font={stat.description.font}
                textColor={stat.description.color}
              >
                {stat.description.value}
              </StyledStatDescription>
            </StyledStatCard>
          ))}
        </StyledStatsGrid>
      </StyledContainer>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  overflow: hidden;
`;

const StyledContainer = styled(Container)`
  ${({ theme }) =>
    theme.isMobile
      ? css`
          margin: 0 -${theme.getValue(8)}px;
        `
      : ""}
`;

export const StyledStatsGrid = styled.div`
  &&& {
    display: flex;
    flex-wrap: ${({ theme }) => (theme.isMobile ? "wrap" : "nowrap")};
    column-gap: ${({ theme }) =>
      theme.isMobile ? theme.getValue(40) : theme.getValue(58)}px;
    row-gap: ${({ theme }) => theme.getValue(30)}px;
    justify-content: center;
    padding: ${({ theme }) =>
      theme.isMobile
        ? `${theme.getValue(24)}px ${theme.getValue(16)}px`
        : `${theme.getValue(60)}px ${theme.getValue(70)}px`};
    background-color: ${({ theme }) => theme.colors.white};
  }
`;

export const StyledStatCard = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  width: ${({ theme }) =>
    theme.isMobile ? `${theme.getValue(142)}px` : `${theme.getValue(260)}px`};
`;

export const StyledStatImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ theme }) =>
    theme.isMobile ? theme.getValue(78) : theme.getValue(152)}px;
  height: ${({ theme }) =>
    theme.isMobile ? theme.getValue(52) : theme.getValue(100)}px;

  img {
    display: block;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
`;

export const StyledStatTitle = styled(Text)`
  &&& {
    font-family: ${({ font: { family = FontFamily.HarmoniaSansStd } = {} }) =>
      family};
    font-weight: ${({ font: { weight = FontWeight.Bold } = {} }) => weight};
    font-size: ${({ theme }) =>
      theme.isMobile ? `${theme.getValue(16)}px` : `${theme.getValue(22)}px`};
    margin: ${({ theme }) => `${theme.getValue(16)}px 0`};
    color: ${({ theme }) => theme.colors.grey1};
  }
`;

export const StyledStatDescription = styled(Text)`
  &&& {
    font-size: ${({ theme }) =>
      theme.isMobile ? `${theme.getValue(16)}px` : `${theme.getValue(22)}px`};
    line-height: 1.1;
    text-align: center;
    color: ${({ theme }) => theme.colors.grey1};
    margin: 0;
  }
`;
